export const orders = [
    {
        id:1,
        orderNumber:"#2341",
        name:"Cien HeemsKerk",
    },
    {
        id:2,
        orderNumber:"#2342",
        name:"Alara Galama",
    },
    {
        id:3,
        orderNumber:"#2343",
        name:"Aurelia Bruno",
    },
    {
        id:4,
        orderNumber:"#2344",
        name:"Levy Beuker",
    },
    {
        id:5,
        orderNumber:"#2345",
        name:"Tiffany Herridson",
    },
]
export const trackings = [
    {
        id:1,
        status:"Delivered",
        text:"Delivered",
        days:"8 days",
    },
    {
        id:2,
        status:"Delivered",
        text:"Delivered at neighbours",
        days:"11 days",
    },
    {
        id:3,
        status:"Delivered",
        text:"Delivered",
        days:"6 days",
    },
    {
        id:4,
        status:"Warning",
        text:"Ready for Pick-up at DHL",
        days:"8 days",
    },
    {
        id:5,
        status:"Shipped",
        text:"Internation flight arrived",
        days:"4 days",
    },
    {
        id:6,
        status:"Shipped",
        text:"Departed from facility",
        days:"1 days",
    },
    {
        id:7,
        status:"Delivered",
        text:"Parcel Delivered at DHL",
        days:"1 days",
    },
    
]